module.exports = __webpack_public_path__ + "static/media/block_icon_image.0857dfa4.svg";